import styled from 'styled-components'
  const NavigationBox = styled.div`
  text-align: ${props =>
    props.center ? 'center' : props.align ? props.align : 'left'};
  @media (max-width: 600px) {
    display:none;
    width: 80%;
    margin: 60px !important;
  }
`;

export default NavigationBox